import { OPEN_DRAWER, CLOSE_DRAWER } from './action';

const initialState = true;

const reducer = (state = initialState, action) => {
    
  switch (action.type) {
    case CLOSE_DRAWER: {
        return false;
    }
    case OPEN_DRAWER: {
        return true;
    }
    default: {
        return state;
        break;
    }
  }
};

export default reducer;
